// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"506":"bc360d51","546":"898ec8e8","744":"3c4fafdb","785":"30278d09","894":"6ee57056","925":"5b06b8de","999":"b33af292"}[chunkId] + ".chunk.css";
};